import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FieldFilter, FilterModel, OperatorFilterEnum } from 'app/models/filter-model';
import { PaymentModel } from 'app/models/payment-model';
import { AppService } from 'app/services/app/app.service';
import { RestService } from 'app/services/rest/rest.service';
import { Utils } from '../../utils/Utils';
import { filter } from 'rxjs';
import * as moment from 'moment-timezone';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Log } from 'app/core/logging/log';

@Component({
  selector: 'app-admin-report-invoice',
  templateUrl: './admin-report-invoice.page.html',
  styleUrls: ['./admin-report-invoice.page.scss'],
})
export class AdminReportInvoicePage implements OnInit {
  
  public OperatorFilterEnum = OperatorFilterEnum;
  payments: PaymentModel[] = [];
  resumen: any = {};
  fieldFilters: FieldFilter[] = [];
  
  constructor(    
    private restService: RestService,
    public appService: AppService,
    private dialog: MatDialog) { 

    }

  ngOnInit() {
    this.fieldFilters.push({
      name: 'date',
      type: 'date',
      multiple: false,
      value: '',
      values: [moment().subtract(1, 'M').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
      options: null,
      label: ''
    });
    this.fieldFilters.push({
      name: 'type',
      type: 'select',
      multiple: false,
      value: '',
      values: [],
      options: ['ZIP', 'EXCEL'],
      label: ''
    });

  }

  open(payment: PaymentModel) {
    this.dialog.open(AdminReportInvoiceModalContent, {
      panelClass: 'responsive-dialog',
      maxWidth: '95vw',
      data: { payment, isNew: payment.uuid == undefined }
    }).afterClosed().subscribe((data) => {
      if (!data) {
        return;
      }
      console.log('data', data);
      this.send();
    });
  }


  setOpen(payment?: PaymentModel) {
    console.log('payment', payment);
    this.open(Object.assign({}, payment));
  }


  mapAsDate(fieldName: string): string[]{
    let field = this.fieldFilters.find(i => i.name == fieldName);
    if(field.values){
      return field.values;
    }
  }

  send(){
    console.log('send', this.fieldFilters)
    let type = this.fieldFilters.find(i => i.name == 'type');
    console.log('send type', type)
    if(type == null){
      return;
    }
    if(type.values[0] == 'ZIP'){
      this.getInvoiceZip();
    }else{
      this.getReport();
    }
  }


  totalFacturado(){
    let sum = 0;
    this.payments.forEach(payment => {
      sum += payment.totalPrice;
    });
    return sum;
  }


  getReport(){
    //console.log('getReport', this.heroForm);
    if(!confirm("Esta seguro de realizar la acción?")) {
      Log.trace("Implement delete functionality here");
      return;
    }
    /*if (this.heroForm.invalid) {
      this.appService.showDangerToast("Paramentro requerido");
      return;
    }*/

      let startDate = Utils.convertStrToDate(this.mapAsDate('date')[0]);
      let endDate = Utils.convertStrToDate(this.mapAsDate('date')[1]);

   // let startDate = Utils.convertStrToDate(this.heroForm.get('startInvoice').value);
   // let endDate = Utils.convertStrToDate(this.heroForm.get('endInvoice').value);
    this.restService.getInvoiceReport("").subscribe(response => {
      console.log('getInvoiceReport', response);
        let filename = `report-${this.mapAsDate('date')[0]}_${this.mapAsDate('date')[1]}`;
        let dataType = response.type;
        let binaryData = [];
        binaryData.push(response);
        let downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, {type: dataType}));
        if (filename)
            downloadLink.setAttribute('download', filename);
        document.body.appendChild(downloadLink);
        downloadLink.click();
            
    });
  }
  
  getInvoiceZip(){
    //console.log('getInvoiceZip', this.heroForm);
    if(!confirm("Esta seguro de realizar la acción?")) {
      Log.trace("Implement delete functionality here");
      return;
    }
    /*if (this.heroForm.invalid) {
      this.appService.showDangerToast("Paramentro requerido");
      return;
    }*/

    let startDate = Utils.convertStrToDate(this.mapAsDate('date')[0]);
    let endDate = Utils.convertStrToDate(this.mapAsDate('date')[1]);
    
    //  let startDate = Utils.convertStrToDate(this.heroForm.get('startInvoice').value);
    //  let endDate = Utils.convertStrToDate(this.heroForm.get('endInvoice').value);
    this.restService.getInvoiceZip("").subscribe(response => {
      console.log('getInvoiceZip', response);
      var blob = new Blob([response], { type: response.type.toString() });
         var url = window.URL.createObjectURL(blob);
         var anchor = document.createElement("a");
         anchor.download = `invoices-${this.mapAsDate('date')[0]}_${this.mapAsDate('date')[1]}.zip`;
         anchor.href = url;
         anchor.click();
            
    });
  }

  
}




@Component({
  selector: 'app-payment-modal-content',
  templateUrl: './admin-report-invoice-modal.component.html'
})
export class AdminReportInvoiceModalContent {
  payment: any;
  isNew: boolean;

  constructor(public activeModal: MatDialogRef<AdminReportInvoiceModalContent>,
              @Inject(MAT_DIALOG_DATA) public data: { payment: any; isNew: boolean },
              private restService: RestService,
              public appService: AppService) {
                this.payment = data?.payment;
                this.isNew = data?.isNew;
              }

             
 
  cancel() {
      this.activeModal.close();
  }

  confirm() {
    console.log('guardarPayment', this.payment);
  }
  

}
